import React, {PureComponent} from 'react';
import {
    FormControlLabel,
    Slider,
    Tooltip,
    Switch,
    Button,
    IconButton,
    Typography,
    List,
    ListSubheader
} from '@material-ui/core'
import ReactPlayer from 'react-player'
import config from '../../config'
import PlayArrowRounded from '@material-ui/icons/PlayCircleFilled'
import PauseCircleFilled from '@material-ui/icons/PauseCircleFilled'
import ReplayRounded from '@material-ui/icons/ReplayRounded'
import VolumeDown from '@material-ui/icons/VolumeDown';
import VolumeMute from '@material-ui/icons/VolumeMute';
import VolumeUp from '@material-ui/icons/VolumeUp';
import BackIcon from '@material-ui/icons/KeyboardArrowLeft';
import moment from 'moment'
import {withStyles} from '@material-ui/core/styles';
import Tally from './tally'
import Bugsnag from '@bugsnag/js'
import seeders from '../../containers/addTracks/seed'

const PurpleSwitch = withStyles({
    switchBase: {
        root: {
            height: 16,
            padding: 0,
        },
        color: 'white',
        '&$checked + $track': {
            backgroundColor: 'white',
        },
    },
    checked: {},
    track: {
        backgroundColor: 'white',
    },
})(Switch);

const PLAYER_MODES = {SAMPLE: 'HEAR FULL TRACK', FULL: "HEAR SAMPLE"};

export default class PlayerComponent extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            playerRef: React.createRef(),
            playing: false,
            playedSeconds: 0,
            volume: 0.5,
            mode: PLAYER_MODES.SAMPLE,
            fullDuration: 0,
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.currentTrack !== this.props.currentTrack) {
            this.setState({playedSeconds: 0, playing: false})
        }
        if (prevProps.isCurrentTrackPlayed === true && this.props.isCurrentTrackPlayed === false) {
            this.setState({playedSeconds: 0})
        }
        if (prevProps.isCurrentTrackPlayed === false && this.props.isCurrentTrackPlayed === true) {
            this.setState({playedSeconds: 0, playing: false})
        }
        this.handleDemoEnd(prevState)
    }

    toggleMode = () => {
        const {mode} = this.state;
        console.log(mode)
        this.setState({
            mode: mode === PLAYER_MODES.SAMPLE ? PLAYER_MODES.FULL : PLAYER_MODES.SAMPLE,
            playedSeconds: 0,
            playing: false,
        })
    };

    handleDemoEnd = (prevState) => {
        const {currentTrack} = this.props;
        const {mode, fullDuration} = this.state;
        if (currentTrack) {
            if (prevState.playedSeconds !== this.state.playedSeconds) {
                if (mode === PLAYER_MODES.SAMPLE) {
                    const duration = (currentTrack.demo.out - currentTrack.demo.in) / 1000;
                    if (this.state.playedSeconds === duration) {
                        // moveToPlayed();
                        this.state.playerRef.current.seekTo(currentTrack.demo.in/1000, 'seconds')
                        this.setState({playing: false, playedSeconds: 0})
                    }
                } else {
                    if (Math.round(this.state.playedSeconds) === Math.round(fullDuration)) {
                        // moveToPlayed();
                        this.state.playerRef.current.seekTo(0, 'seconds')
                        this.setState({playing: false, playedSeconds: 0})
                    }
                }
            }
        }
    };

    onProgress = ({playedSeconds}) => {
        const {mode} = this.state;
        let newPlayedSeconds = Math.round(playedSeconds);
        if (mode === PLAYER_MODES.SAMPLE) {
            newPlayedSeconds = Math.round(playedSeconds - (this.props.currentTrack.demo.in / 1000))
        }
        this.setState({playedSeconds: newPlayedSeconds})
    };

    onPlayerReady = () => {
        // this.setState({playing: true})
    };

    onDuration = (duration) => {
        this.setState({fullDuration: duration})
    };

    onPausePlay = () => {
        const {playing} = this.state;
        const {isCurrentTrackPlayed} = this.props;
        if (isCurrentTrackPlayed) {
            this.onReplay()
        } else {
            this.setState({playing: !playing})
        }
    };

    onReplay = () => {
        const {replayTrack} = this.props;
        replayTrack();
        this.setState({playedSeconds: 0, playing: true})
    };

    renderIcon = () => {
        const {playing, playedSeconds, fullDuration, mode} = this.state;
        const {currentTrack} = this.props;
        const duration = (currentTrack.demo.out - currentTrack.demo.in) / 1000;
        if (mode === PLAYER_MODES.SAMPLE) {
            if (playedSeconds >= duration) {
                return <Tooltip title={"REPLAY track"}><ReplayRounded style={{fontSize: 50}}/></Tooltip>
            }
        } else {
            if (playedSeconds >= fullDuration) {
                return <Tooltip title={"REPLAY track"}><ReplayRounded style={{fontSize: 50}}/></Tooltip>
            }
        }
        if (playing) {
            return <Tooltip title={"PAUSE track"}><PauseCircleFilled style={{fontSize: 50}}/></Tooltip>
        }
        if (!playing) {
            return <Tooltip title={"PLAY track"}><PlayArrowRounded style={{fontSize: 50}}/></Tooltip>
        }
    };

    getVolumeIcon = () => {
        const {volume} = this.state;
        if (volume === 0) {
            return <VolumeMute style={{color: 'white',}}/>
        }
        if (volume === 1) {
            return <VolumeUp style={{color: 'white',}}/>
        }
        return <VolumeDown style={{color: 'white',}}/>
    };

    renderTimeline = () => {
        const {currentTrack} = this.props;
        const {playedSeconds, mode, fullDuration, playerRef} = this.state;

        let duration = 0;

        if (mode === PLAYER_MODES.SAMPLE) {
            duration = (currentTrack.demo.out - currentTrack.demo.in) / 1000
        } else {
            duration = fullDuration;
        }
        if (mode === PLAYER_MODES.SAMPLE) {
            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                paddingTop: 5,
                paddingLeft: 15,
                paddingRight: 15,
                alignItems: 'flex-start'
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                }}>
                    <Typography variant={'caption'} style={{color: 'white', fontWeight: 'bold', maxWidth: 200,}}>
                        {currentTrack.artist_name}
                    </Typography>
                    <Typography variant={'caption'} style={{color: 'white', maxWidth: 200,}}>
                        {currentTrack.track_name}
                    </Typography>
                </div>
                <Typography variant="overline" style={{fontSize: 18, fontWeight: 'bold', color: 'white'}}
                            display="block">
                    {moment().startOf('day')
                        .seconds(duration - playedSeconds)
                        .format('m:ss')}
                </Typography>
            </div>
        } else {
            return <div style={{
                display: 'flex',
                flexDirection: 'column',
                paddingTop: 5,
                paddingLeft: 15,
                paddingRight: 15,
                alignItems: 'center'
            }}>
                <Typography variant={'caption'} style={{color: 'white', fontWeight: 'bold'}}>
                    {currentTrack.artist_name}
                </Typography>
                <Typography variant={'caption'} style={{color: 'white',}}>
                    {currentTrack.track_name}
                </Typography>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                    <Typography variant="overline" style={{fontSize: 10, color: 'white'}}
                                display="block">
                        {moment().startOf('day')
                            .seconds(playedSeconds)
                            .format('m:ss')}
                    </Typography>
                    <Typography variant="overline" style={{fontSize: 10, color: 'white'}}
                                display="block">
                        {moment().startOf('day')
                            .seconds(duration)
                            .format('m:ss')}
                    </Typography>
                </div>
                <Slider style={{width: '100%', color: 'white'}}
                        value={playedSeconds / duration}
                        max={1}
                        min={0}
                        step={0.001}
                        onChange={(e, v) =>
                            this.setState({playedSeconds: v * duration}, () => playerRef.current.seekTo(v, 'fraction'))
                        }
                        aria-labelledby="continuous-slider"/>
            </div>
        }
    };

    render() {
        const {currentTrack, hideCurrentTrack, trackVotes: votes, showTally} = this.props;
        const {playerRef, playing, volume, mode} = this.state;
        let trackUrl = null;
        let hlsConfig = {};
        if (!currentTrack) {
            return null
        }
        if (currentTrack) {
            const mediaHost = Object.keys(seeders).includes(currentTrack.track_id) ? 'https://media.tweedlmusic.com' :config.mediaStreamingHost
            trackUrl = `${mediaHost}/${currentTrack.media_id}/${currentTrack.media_id}.m3u8?x-request=xhr`;
            hlsConfig = {
                file:{
                    attributes: {
                        crossOrigin: 'anonymous'
                    },
                    hlsOptions: {
                        startPosition: mode === PLAYER_MODES.SAMPLE ? (currentTrack.demo.in / 1000) : 0
                    }
                },
            };
        }
        return (
            <List style={{paddingTop: 0, paddingBottom: 0}}
                  subheader={
                      <ListSubheader style={{
                          backgroundColor: 'black',
                          paddingLeft: 0,
                          paddingRight: 0,
                          textAlign: 'center',
                          color: 'white',
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          height: 49
                      }} component="div" id="nested-list-subheader">
                          <Tooltip title={"HIDE track"}>
                              <Button
                                  style={{width: 60, color: 'white',}}
                                  onClick={hideCurrentTrack}
                                  startIcon={<BackIcon/>}
                              >Back</Button>
                          </Tooltip>
                          <Tooltip title={"MODE"}>
                              <FormControlLabel
                                  labelPlacement={'top'}
                                  control={<PurpleSwitch
                                      checked={mode === PLAYER_MODES.FULL}
                                      onChange={this.toggleMode}
                                      name={PLAYER_MODES[mode]}
                                      color="primary"
                                      size={"small"}
                                  />}
                                  label={<Typography style={{fontSize: 10}}
                                                     variant={'caption'}>{mode}</Typography>}
                              />
                          </Tooltip>
                          <div style={{width: 50, color: 'white',}}>
                              {/*<Typography>#{currentTrack.order}</Typography>*/}
                          </div>
                      </ListSubheader>
                  }
            >
                <div
                    style={{
                        width: 280,
                        height: 280,
                        position: 'relative',
                    }}
                >
                    <img
                        alt={'cover-art'}
                        style={{position: 'relative'}}
                        src={`${config.cloudinaryPublicUrl}/w_280,h_280,c_scale/${
                            currentTrack.cover_art
                            }.jpg`}
                    />
                    <Tally show={showTally} votes={votes}/>
                </div>
                {this.renderTimeline()}
                <div style={{display: 'flex', width: '100%', justifyContent: 'center'}}>
                    <IconButton style={{color: 'white'}} onClick={this.onPausePlay}>
                        {this.renderIcon()}
                    </IconButton>
                </div>
                <div style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    {this.getVolumeIcon()}
                    <Slider style={{width: '70%', color: 'white'}} value={volume * 100}
                            onChange={(e, v) => {
                                this.setState({volume: v / 100})
                            }}
                            aria-labelledby="continuous-slider"/>
                </div>
                <ReactPlayer
                    width={0}
                    height={0}
                    onDuration={this.onDuration}
                    key={currentTrack.track_id + `${this.props.isCurrentTrackPlayed}_${mode}`}
                    onProgress={this.onProgress}
                    onReady={this.onPlayerReady}
                    ref={playerRef}
                    url={trackUrl}
                    playing={playing}
                    loop={false}
                    volume={volume}
                    config={hlsConfig}
                    onError={(t, error) => {
                        if (error) {
                            const {type, url} = error;
                            Bugsnag.notify(new Error(`CORS error type: ${type}, url:${url}`))
                        }
                    }}
                />
            </List>
        )
    }
}